import { render, staticRenderFns } from "./sceneaccess.vue?vue&type=template&id=665c7098&scoped=true"
import script from "./sceneaccess.vue?vue&type=script&lang=js"
export * from "./sceneaccess.vue?vue&type=script&lang=js"
import style0 from "./sceneaccess.vue?vue&type=style&index=0&id=665c7098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665c7098",
  null
  
)

export default component.exports